import * as _blueimpLoadImage from 'blueimp-load-image';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupBlueimpLoadImage } from 'blueimp-load-image';

export const blueimpLoadImage = _rollupBlueimpLoadImage || _blueimpLoadImage;
